module.exports = __webpack_public_path__ + "img/permata.8c7b3941.png";